import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step8 from './Step8-redux';

export default compose(
  withRouter,
  withNextStep
)(Step8);
